var React = require('react');

function DoubleArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.476 5.64 10.238.834m0 0L5 5.64M10.238.834v6.355M5 14.362l5.238 4.805m0 0 5.238-4.805m-5.238 4.805V7.457","stroke":"#427FC0","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

DoubleArrow.defaultProps = {"width":"20","height":"20","fill":"none"};

module.exports = DoubleArrow;

DoubleArrow.default = DoubleArrow;
